import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Button, Fade, Container, Row, Col, Form} from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import {Formik} from 'formik';
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import {Redirect} from 'react-router-dom';
import CommonMetaTag from './common-meta-tag';
import Configuration from '../config';
import {imageTypes, affiliationType} from '../constants';
import {useTranslation} from 'react-i18next';
import {FaCalendarAlt, FaSave, FaTrashAlt} from 'react-icons/fa';
import 'filepond/dist/filepond.min.css';
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

registerPlugin(FilePondPluginImagePreview);

const PartnerService = ({
  ownedService,
  save,
  token,
  removeFile,
  showCalendar,
  deleteService,
  profile,
  affiliations
}) => {
  const {t} = useTranslation();
  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  if (ownedService === null) {
    return null;
  }

  const imagesNames = (ownedService.imagesNames || []).map(f => {
    return {
      source: f,
      options: {
        type: 'local'
      }
    };
  });

  let dialog = null;
  const onRemove = id => () => {
    dialog.show({
      title: t('CONFIRM'),
      body: t('SERVICE_DELETE_CONFIRM'),
      actions: [
        Dialog.Action(
          t('DELETE'),
          () => deleteService(id),
          'btn btn-secondary'
        ),
        Dialog.Action(
          t('NO'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={Object.assign({}, ownedService)}
      onSubmit={save}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        values
      }) => {
        return (
          <Fragment>
            <CommonMetaTag/>
            <Fade in appear style={{transition: 'opacity 0.30s linear', marginTop: 100}}>
              <Container className="partner-resource-editor">
                <Row className="justify-content-center">
                  <Col xs={12} sm={10} md={8} lg={7} className="partner-resource-editor__panel">
                    <Row className="partner-resource-editor__header">
                      <Col>
                        <h4>{values.id ? values.name : t('NEW_SERVICE')}</h4>
                      </Col>
                      {
                        ownedService.id === null ?
                          null :
                          <Col>
                            <Button variant="light" className="float-right partner-resource-editor__calendar-btn" type="button" onClick={showCalendar(ownedService.id)}><FaCalendarAlt/>{t('CALENDAR')}</Button>
                          </Col>
                      }
                    </Row>
                    {
                      ownedService.id === null ?
                        null :
                        <div className="partner-resource-editor__media">
                          <div className="partner-resource-editor__section-heading">
                            <span>01</span>
                            <div><h5>{t('IMAGES')}</h5><p>{t('SERVICE_IMAGES_INTRO')}</p></div>
                          </div>
                          {/*
                          <Form.Label>{t('FIELD_VIDEO_COVER')}</Form.Label>
                          <FilePond
                            files={background}
                            server={
                              {
                                url: `${Configuration.apiEndPoint}/partners/`,
                                process: {
                                  url: `./services/${ownedService.id}/images`,
                                  ondata: formData => {
                                    formData.append('image_type', imageTypes.background);
                                    return formData;
                                  }
                                },
                                revert: `./services/${ownedService.id}/images`,
                                restore: `./services/${ownedService.id}/images`,
                                fetch: `./services/${ownedService.id}/images`,
                                load: `./services/${ownedService.id}/images?load=`,
                                headers: {Authorization: `Bearer ${token}`},
                                remove: (source, load) => {
                                  removeFile(source, ownedService.id);
                                  load();
                                }
                              }
                            }
                          />
                          */}
                          <Form.Label>{t('PHOTO')}</Form.Label>
                          <FilePond
                            allowMultiple
                            files={imagesNames}
                            server={
                              {
                                url: `${Configuration.apiEndPoint}/partners/`,
                                process: {
                                  url: `./services/${ownedService.id}/images`,
                                  ondata: formData => {
                                    formData.append('image_type', imageTypes.service);
                                    return formData;
                                  }
                                },
                                revert: `./services/${ownedService.id}/images`,
                                restore: `./services/${ownedService.id}/images`,
                                fetch: `./services/${ownedService.id}/images`,
                                load: `./services/${ownedService.id}/images?load=`,
                                headers: {Authorization: `Bearer ${token}`},
                                remove: (source, load) => {
                                  removeFile(source, ownedService.id);
                                  load();
                                }
                              }
                            }
                            maxFiles={3}
                          />
                        </div>
                    }
                    <Form className="partner-resource-editor__form" onSubmit={handleSubmit}>
                      <div className="partner-resource-editor__section-heading">
                        <span>02</span>
                        <div><h5>{t('MAIN_INFORMATION')}</h5><p>{t('SERVICE_MAIN_INFO_INTRO')}</p></div>
                      </div>
                      <Form.Group>
                        <Form.Label>{t('NAME')}*</Form.Label>
                        <Form.Control required name="name" type="text" placeholder={t('NAME')} maxLength="50" value={values.name || ''} onChange={handleChange}/>
                        <Form.Text className="text-muted">
                          {t('NAME')}
                        </Form.Text>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('BRIEF_DESCRIPTION')}*</Form.Label>
                        <Form.Control required name="briefDescription" type="text" placeholder={t('BRIEF_DESCRIPTION')} maxLength="160" value={values.briefDescription || ''} onChange={handleChange}/>
                        <Form.Text className="text-muted">
                          {t('BRIEF_DESCRIPTION') + ' (max 32 caratteri)'}
                        </Form.Text>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('DESCRIPTION')}*</Form.Label>
                        <Form.Control required name="description" type="text" placeholder={t('DESCRIPTION')} maxLength="255" value={values.description || ''} onChange={handleChange}/>
                        <Form.Text className="text-muted">
                          {t('DESCRIPTION')}
                        </Form.Text>
                      </Form.Group>
                      <div className="partner-resource-editor__section-heading">
                        <span>03</span>
                        <div><h5>{t('BOOKING_AND_ACCESS')}</h5><p>{t('SERVICE_BOOKING_ACCESS_INTRO')}</p></div>
                      </div>
                      {
                      affiliations.filter(a => a.type === affiliationType.partner).length > 0 ?
                      <Form.Group className="partner-resource-editor__choices">
                        <Form.Label>{t('CHOOSE_AFFILIATIONS')}</Form.Label>
                        {
                          affiliations.filter(a => a.type === affiliationType.partner).map((affiliation, index) => {
                            return (
                              <Form.Check
                                key={index}
                                type="checkbox"
                                label={affiliation.name}
                                checked={values.affiliationsIds && values.affiliationsIds.includes(affiliation.affiliationId)}
                                onChange={val => setFieldValue('affiliationsIds', val.target.checked ? [...(values.affiliationsIds || []), affiliation.affiliationId] : values.affiliationsIds.filter(a => a !== affiliation.affiliationId))}
                                name="affiliationsIds"
                                value={affiliation.affiliationId}
                              />
                            );
                          })
                        }
                      </Form.Group>
                      : null
                      }
                      {profile.isSpecialist ?
                      null :
                      <Form.Group className="partner-resource-editor__choices">
                        <Form.Label>{t('SERVICE_PLANNING')}*</Form.Label>
                        <Form.Check required name="bookable" type="radio" label={t('FIELD_PLANNING_BOOKING')} checked={values.bookable} onChange={() => setFieldValue('bookable', true)}/>
                        <Form.Check required name="bookable" type="radio" label={t('FIELD_PLANNING_CALENDAR')} checked={values.bookable === false} onChange={() => setFieldValue('bookable', false)}/>
                      </Form.Group>
                      }
                      <div className="partner-resource-editor__section-heading">
                        <span>04</span>
                        <div><h5>{t('COSTS_AND_TERMS')}</h5><p>{t('RESOURCE_COSTS_TERMS_INTRO')}</p></div>
                      </div>
                      <Form.Group>
                        <Form.Label>{t('ADDITIONAL_COST_INFO')}</Form.Label>
                        <Form.Control name="additionalCost" as="textarea" maxLength={255} rows="6" placeholder={t('ADDITIONAL_COST_INFO')} value={values.additionalCost || ''} onChange={handleChange}/>
                        <Form.Text className="text-muted">
                          {t('ADDITIONAL_COST')}
                        </Form.Text>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('POLICY')}</Form.Label>
                        <Form.Control name="bookingPolicy" as="textarea" maxLength={255} placeholder={t('POLICY_PLACEHOLDER')} value={values.bookingPolicy || ''} onChange={handleChange}/>
                        <Form.Text className="text-muted">
                          {t('POLICY_DESC')}
                        </Form.Text>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('FIELD_UNBOOKING_POLICY')}*</Form.Label>
                        <Form.Check required name="unbookableHours" type="radio" label={t('FIELD_UNBOOKING_OFFLINE')} checked={values.unbookableHours === null} onChange={() => setFieldValue('unbookableHours', null)}/>
                        <Form.Check required name="unbookableHours" type="radio" label={t('FIELD_UNBOOKING_ONLINE')} checked={values.unbookableHours != null} onChange={() => setFieldValue('unbookableHours', values.unbookableHours || 24)}/>
                        <Form.Control required name="unbookableHours" type="number" min={0} value={values.unbookableHours} disabled={values.unbookableHours === null} onChange={handleChange} placeholder={t('ENTER_HOURS')}/>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>{t('TERM_OF_USE')}</Form.Label>
                        <Form.Control name="termOfUse" as="textarea" maxLength={255} placeholder={t('TERM_OF_USE')} value={values.termOfUse || ''} onChange={handleChange}/>
                        <Form.Text className="text-muted">
                          {t('TERM_OF_USE')}
                        </Form.Text>
                      </Form.Group>
                      <div className="partner-resource-editor__actions">
                        <Button type="submit"><FaSave/>{t('SAVE')}</Button>
                        {
                          ownedService.id === null ?
                            null :
                            <Button type="button" variant="outline-danger" onClick={onRemove(ownedService.id)}><FaTrashAlt/>{t('DELETE')}</Button>
                        }
                      </div>
                    </Form>
                  </Col>
                </Row>
              </Container>
            </Fade>
            <Dialog
              ref={el => {
                dialog = el;
              }}/>
          </Fragment>
        );
      }}
    </Formik>
  );
};

PartnerService.propTypes = {
  ownedService: PropTypes.object,
  save: PropTypes.func.isRequired,
  removeFile: PropTypes.func.isRequired,
  deleteService: PropTypes.func.isRequired,
  showCalendar: PropTypes.func.isRequired,
  token: PropTypes.string
};

PartnerService.defaultProps = {
  ownedService: null,
  token: null
};

export default PartnerService;
